import { render, staticRenderFns } from "./PostDetailCard.vue?vue&type=template&id=1d695f64&scoped=true&"
import script from "./PostDetailCard.vue?vue&type=script&lang=js&"
export * from "./PostDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./PostDetailCard.vue?vue&type=style&index=0&id=1d695f64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d695f64",
  null
  
)

export default component.exports